import { render, staticRenderFns } from "./DashboardIcon.vue?vue&type=template&id=3c3f631f&scoped=true&"
import script from "./DashboardIcon.vue?vue&type=script&lang=js&"
export * from "./DashboardIcon.vue?vue&type=script&lang=js&"
import style0 from "./DashboardIcon.vue?vue&type=style&index=0&id=3c3f631f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c3f631f",
  null
  
)

export default component.exports